<template>
  <div class="about">
    <h1 class="page-title">WORK</h1>

    <section class="archive-filters">
      <ul v-if="tagLoaded" class="tags">
        <li class="tag">
          <router-link
          :to="{
              name: 'Work'
          }"
          @click.native="clearTag()"
          >ALL</router-link>
        </li>
        <li 
        :class="{tag:true, active:(activeTag==tag.id)}" 
        v-for="tag in tags" :key="tag.slug">
        <router-link
          :to="{
              name: 'Work',
              hash: '#'+tag.slug
          }"
          @click.native="filterTag(tag.id)"
          >
          {{tag.name}}
          </router-link>
          </li>
      </ul>
    </section>

    <Archive 
      name="post" 
      routeName="WorkDetail" 
      :filterTags="[activeTag]"
      >
    </Archive>
  </div>
</template>


<script>
import PageData from '@/mixins/PageData'
import Archive from '../components/Archive'

export default {
  components:{Archive},
  mixins: [PageData],

  data:()=>({
    tags:null,
    activeTag:null,
    tagLoaded:false    
  }),
  methods:{
    
    filterTag(id){
      this.activeTag = this.activeTag == id ? null : id;
    },
    clearTag(){
      this.activeTag = null;
    },
    getTagIdBySlug(slug){
      let tag = this.tags.filter((t)=>t.slug==slug);
      return tag.length>0 ? tag[0].id : false;
    }
  },
  mounted(){

    this.getTags('post').then(data=>{
      this.tags = data;
      this.tagLoaded = true;

      const hash = this.$route.hash.substr(1);
      const tagid = this.getTagIdBySlug(hash);
      if(tagid) this.filterTag(tagid);
    })

    
  }
}
</script>